export const makePrompt = (typed: string, selected: string): string | null => {
    const t = typed.trim();
    const s = selected.trim();
    if (!t || !s) return null;
    const sep = t.endsWith(":") ? " " : ": ";
    return t + sep + s;
  };